import { render, staticRenderFns } from "./DetailPenawaranRejected.vue?vue&type=template&id=8f68f662&scoped=true"
import script from "./DetailPenawaranRejected.vue?vue&type=script&lang=js"
export * from "./DetailPenawaranRejected.vue?vue&type=script&lang=js"
import style0 from "./DetailPenawaranRejected.vue?vue&type=style&index=0&id=8f68f662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f68f662",
  null
  
)

export default component.exports